import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// The "section module" header seen across Monarch / monday / Amazon: a small
// uppercase eyebrow title, an optional count, and an optional right-side action.
export function SectionHeader({
  title,
  count,
  action,
  className,
}: {
  title: string;
  count?: number;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center justify-between gap-3 mb-3", className)}>
      <h2 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
        {title}
        {count != null ? (
          <span className="ml-2 text-foreground/70 tabular-nums normal-case tracking-normal">
            {count}
          </span>
        ) : null}
      </h2>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
